import { Button, InputBaseComponentProps, TextField } from '@mui/material';
import { useInputState } from 'lib/hooks/useInputState';
import { isEmptyString } from 'lib/typeguards';
import React from 'react';
import MaskedInput from 'react-text-mask';
import { Row } from 'ui/Flex';

const ExpiryInput = (props: InputBaseComponentProps) => (
    <MaskedInput mask={[/[0-1]/, /[0-9]/, '/', '2', '0', /[2-9]/, /[0-9]/]} {...props} />
);

interface TransactionExpiryInputProps {
    onChange: (value?: string) => void;
    value?: string;
    disabled?: boolean;
    size?: 'small' | 'medium';
    paper?: boolean;
}

function isValidExpiry(value?: string) {
    return !value || value.length === 7;
}

export const TransactionExpiryInput: React.FC<TransactionExpiryInputProps> = ({
    onChange,
    value,
    disabled,
    paper,
    size
}) => {
    const [field, handleChange] = useInputState(value);
    const handleClick = React.useCallback(() => {
        onChange(isEmptyString(field) ? undefined : field);
    }, [field, onChange]);
    const renderButton = React.useCallback(
        () => (
            <Button
                disabled={(value === field && isValidExpiry(value)) || disabled}
                onClick={handleClick}
                variant="outlined"
                size={size}
                sx={{ mr: size === 'small' ? -1 : 0 }}
            >
                {value === field || field.length ? 'Submit' : 'Clear'}
            </Button>
        ),
        [disabled, field, handleClick, size, value]
    );
    return (
        <Row>
            <TextField
                variant="outlined"
                value={field}
                size={size}
                onChange={handleChange}
                label="Card Expiry"
                sx={{ backgroundColor: paper ? 'background.paper' : undefined }}
                InputProps={{ endAdornment: renderButton(), inputComponent: ExpiryInput }}
                InputLabelProps={{ shrink: !!field }}
                disabled={disabled}
            />
        </Row>
    );
};
